export default __webpack_public_path__ + "static/media/infra-18.145df695.webp";